<template>
	<div
		v-if="isInStock(product) === false"
		class="absolute inset-x-0 top-1/2 -translate-y-1/2 text-center bg-background-secondary text-body-secondary p-2 font-bold pointer-events-none leading-3 md:leading-5 lg:leading-6 typo-body-xl"
	>
		Vyprodáno
	</div>
</template>

<script setup lang="ts">
	import {isInStock} from '~/utils';
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';

	type Props = {
		product: ProductDetail
	};

	defineProps<Props>();
</script>
